import { createSlice } from '@reduxjs/toolkit'

import { fetchfeatures } from '../thunks/Features'
import { IFeaturesProps } from 'types/Features'

const initialState: IFeaturesProps = {
  features: {},
  fetching: false,
  doneFetching: false,
  fetchError: '',
}

export const features = createSlice({
  name: 'features',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchfeatures?.pending?.toString()]: (state) => {
      state.fetching = true
    },
    [fetchfeatures?.fulfilled?.toString()]: (state, action) => {
      state.features = action.payload
      state.fetching = false
      state.doneFetching = true
    },
    [fetchfeatures?.rejected?.toString()]: (state, action) => {
      state.fetching = false
      state.fetchError = action.payload
      state.doneFetching = false
    },
  },
})

export default features.reducer
